import React, { useState } from 'react';
import Layout from '@/components/Layout';
import WelcomeScreen from '@/components/WelcomeScreen';
import QuizSection from '@/components/QuizSection';
import ResultsScreen from '@/components/ResultsScreen';
import EmailCapture from '@/components/EmailCapture';
import { quizSections } from '@/data/quizData';
import { calculateScores } from '@/utils/scoring';

function App() {
  const [step, setStep] = useState(0);
  const [answers, setAnswers] = useState({});
  const [results, setResults] = useState(null);
  const [firstName, setFirstName] = useState('');

  const handleNextSection = () => {
    if (step < 4) {
      setStep(step + 1);
    } else if (step === 4) {
      const calculated = calculateScores(answers);
      setResults(calculated);
      // Change: Move directly to Email Capture instead of Results
      setStep(5);
    }
  };

  return (
    <Layout>
      {step === 0 && <WelcomeScreen onStart={() => setStep(1)} />}
      
      {step >= 1 && step <= 4 && (
        <QuizSection 
          section={quizSections[step - 1]} 
          index={step - 1} 
          totalSections={4} 
          answers={answers} 
          setAnswers={setAnswers} 
          onNext={handleNextSection} 
        />
      )}

      {step === 5 && results && (
        <EmailCapture 
          results={results} 
          onComplete={(name) => {
            setFirstName(name);
            setStep(6);
          }} 
        />
      )}

      {step === 6 && results && (
        <ResultsScreen 
          results={results} 
          firstName={firstName} 
        />
      )}
    </Layout>
  );
}

export default App;